import { ComponentFactoryResolver, Directive, Input, OnInit, ViewContainerRef } from '@angular/core';
import { Cell } from './cell';

@Directive({
  selector: '[vaCell]',
  standalone: false,
})
export class CellDirective implements OnInit {
  @Input() cell: Cell;

  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef,
  ) {}

  ngOnInit(): void {
    const cf = this.resolver.resolveComponentFactory(this.cell.component);
    const c = this.container.createComponent(cf);
    c.instance.config = this.cell.config;
  }
}
